<template>
  <section class="packageIndex">
	<!--顶部导航区-->
	<nav :class="{'isShowNav':isShowNav}">
	  <ul>
		<li v-for="(item,index) in navData" :key="index"
			@click="toView(item,index)">
		  <img :src="'/images/package/'+item.icon+'.png'" align="middle">
		</li>
	  </ul>
	</nav>
	
	<!--背景区-->
	<div class="backgroundWrap">
	  <div class="hGroup">
		<h2 class="bold">{{userInfo.nickName}}</h2>
		<h3 class="f28">每一只包，都见证着你的时光</h3>
	  </div>
	  
	</div>
	
	<!--内容区-->
	<div class="maskWrap" ref="maskWrap">
	 
	  <ul class="navList">
		<li v-for="(item,index) in navData" :key="index"
			@click="toView(item,index)"
			:style="{'background-image':'url(/images/package/'+item.bgIcon+'.png)'}">
		  <h3>{{item.countObjKey==='favorite'?countObj[item.countObjKey].total:countObj[item.countObjKey]}}</h3>
		  <h4 class="f24 bold">{{item.name}}</h4>
		</li>
	  </ul>
	  
	  <!--内容区-->
	  <div class="inner">
		<div class="topBar"></div>
		<div  v-if="historyList.length>=8">
		  <h5 class="bold">你浏览的包包</h5>
		  <div class="viewHistory" >
			<ul class="twoColumn clearfix" id="twoColumn"
				:style="{width:getWidth}"
				ref="historyColumn">
			  <li  v-for="(item,index) in showHistoryList" :key="index"
				   @click="addViewHistory(item.sku)"
				   :style="{left:item.left+'px',top:item.top+'px'}">
				<img :src="item.productInfo.baseProductPics[0] | formatImgUrl(160,160,true) " align="middle"/>
			  </li>
			</ul>
		  </div>
		</div>
		
		<water-fall :timeLineData="timeLineData"></water-fall>
		
		<!--无数据-->
		<div v-if="historyList.length <8  && timeLineData.length === 0"
			 class="noData">
		  <img src="/images/noData/no_package.png" align="middle">
		</div>
	  </div>
	</div>
  </section>
</template>

<script>
  import packageApi from '@api/package'
  import { mapState, mapActions } from 'vuex'
  import WaterFall from "../../../components/waterFall";
  export default {
    name: "index",
    components: {WaterFall},
    data() {
      return {
        isShowNav:false,
		navData:[
		  {name:'在背的包',pathName:'purchaseOrder',query:{key:'tabActiveIndex',value:0},icon:'icon_04',bgIcon:'icon_01',countObjKey:'myOrder'},
		  {name:'想背的包',pathName:'collectList',icon:'icon_05',bgIcon:'icon_02',countObjKey:'favorite'},
		  {name:'换背的包',pathName:'purchaseOrder',icon:'icon_06',query:{key:'tabActiveIndex',value:1},bgIcon:'icon_03',countObjKey:'pastOrder'},
		],
		countObj:{
          favorite: 0,
          myOrder: 0,
          pastOrder: 0
		},
        historyList:[],
		showHistoryList:[],
		timeLineData:[],
		isLoading:false,
		isFinished:false,
		pageConfig:{
          pageNum:1,
		  pageSize:10,
		  total:0
		}
	  }
    },
    watch: {},
    computed: {
      ...mapState({
		userInfo:state=>state.user.userInfo
	  }),
      mySwiper() {
        return this.$refs.mySwiper.swiper
      },
      clientWidth(){
        return document.documentElement.clientWidth
      },
	  getWidth(){
        return this.showHistoryList.length/2*95*this.clientWidth/375+'px'
	  }
	},
    created() {
      this.getTimeLines();
      this.getViewHistoryList();
      this.getPackageCount();
    },
    mounted() {
      this.$refs['maskWrap'].addEventListener("scroll", this.onScroll);
    },
    methods: {
      ...mapActions({
        addViewHistory:'user/addViewHistory'
      }),
      onScroll() {
        const maskWrapDom = this.$refs['maskWrap'];
				const scrollTop = maskWrapDom.scrollTop;
				console.log("scrollTop",scrollTop)
        const clientHeight = maskWrapDom.clientHeight;
        const scrollHeight = maskWrapDom.scrollHeight;
        if (scrollTop > 380 ) {
          this.isShowNav = true
        }else {
          this.isShowNav = false
		}
        // 加载中或加载完成后 不触发上拉加载
        if(this.isLoading || this.isFinished){
          return
		}
        if(scrollTop + clientHeight > scrollHeight-100) {
          this.getTimeLines()
		}
      
      },
      //在背的包、换过的包和想背的包数量
      getPackageCount(){
        packageApi.getPackageCount().then(res=>{
          this.countObj = res;
        })
	  },
      toView(item){
        if(item.pathName){
          this.$router.push({name:item.pathName,query:{[item.query?.key]:item.query?.value}})
		}
	  },
	  //获取时间轴列表
      getTimeLines(){
        this.isLoading = true;
        packageApi.getTimeLines({
		  ...this.pageConfig
		}).then(res=>{
          this.isLoading = false;
          let list = [...this.timeLineData];
		  this.timeLineData = list.concat(res.result);
          this.pageConfig.total = res.total;
          if(this.timeLineData.length >= this.pageConfig.total){
            this.isFinished = true;
          }else {
            this.pageConfig.pageNum++;
          }
		}).catch(res=>{
          this.isLoading = false
		})
	  },
      getViewHistoryList(){
        packageApi.getViewHistoryList({
		  pageSize: 30,
		  pageNum: 1
		}).then(res => {
		  
		  this.historyList = [...res.result];
		  if(this.historyList.length>=8){
            this.showHistoryList = [...this.getShowHistoryList()];
            setTimeout(()=>{
              const historyColumn  = this.$refs['historyColumn'];
              let step = -.1;
              setInterval(()=>{
                const length = this.showHistoryList.length;
                const scale = this.clientWidth/375;
                if(step < -length/2*95*scale+500){
                  this.showHistoryList =  [...this.showHistoryList,...this.getShowHistoryList()]
                }
                historyColumn.style.transform='translateX('+step+'px)';
                // historyColumn.scrollTo(step,0) ;
                step-=.1
              },50)
            },500)
		  }
		
		})
	  },
	  getShowHistoryList(){
        const historyListArr = [...this.historyList];
        const arr = [];
        const scale = this.clientWidth/375;
        const showHistoryListLength = this.showHistoryList.length;
        const totalLength = historyListArr.length+showHistoryListLength;
        for(let i = showHistoryListLength;i<totalLength;i++){
          if(i % 2){
            // 下标为奇数 第二排
			arr.push({
              ...historyListArr[i-showHistoryListLength],
              left:(i-1)/2*95*scale-30,
              top: 95*scale
			})
          }else {
            // 第一排
            arr.push({
              ...historyListArr[i-showHistoryListLength],
              left:i/2*95*scale,
              top: 0
            })
          }
        }
        // console.table(arr)
        return arr
		
	  }
	  
	}

  }
</script>

<style lang="scss" scoped>
.packageIndex{
  /*position: relative;*/
  /*顶部导航区*/
  nav{
	position: fixed;
	top:-100px;
	left: 0;
	width: 100%;
	height: 100px;
	padding: 28px 118px;
	z-index: 20;
	background: $white-color;
	box-shadow: $base-shadow;
	border-radius:0 0 20px 20px;
	box-sizing: border-box;
	transition: .5s ease-in-out;
	-webkit-transform: translateZ(0);
	&.isShowNav{
	  top: -1px;
	}
	ul{
	  display: flex;
	  justify-content: space-between;
	  
	  img{
		width: 44px;
	  }
	}
  }
  
  /*背景区*/
  .backgroundWrap{
	width: 100%;
	height: 100%;
	position: fixed;
	left: 0;
	top:0;
	background: $primary-color;
	color: $white-color;
	.hGroup{
	  padding: 100px 40px 200px;
	  h2{
		font-size: 50px;
		margin-bottom: 34px;
	  }
	}
	
  }
 
  /*内容区*/
  .maskWrap{
	width: 100%;
	height: 100%;
	overflow-y: auto;
	box-sizing: border-box;
	position: absolute;
	left: 0;
	top:0;
	.navList{
	  display: flex;
	  justify-content: space-between;
	  padding: 430px 60px 166px;
	  li{
		width: 160px;
		height: 348px;
		background: no-repeat center center;
		background-size: 160px;
		text-align: center;
		h3{
		  font-size: 56px;
		  line-height: 80px;
		  padding-top: 106px;
		  font-weight: bold;
		}
		h4{
		  line-height: 34px;
		}
	  }
	}
	
	.inner{
	  border-radius:60px 60px 0 0;
	  min-height: 800px;
	  margin: 0 20px;
	  padding: 16px 0 160px;
	  background: $white-color;
	  .topBar{
		width:260px;
		height:10px;
		background: $primary-color;
		margin: 0 auto 88px;
	  }
	  h5{
		padding: 0 40px 50px;
		font-size: 36px;
	  }
	  .viewHistory{
		margin-bottom: 90px;
		overflow-x:hidden;
		overflow-y: hidden;
		ul{
		  height: 400px;
		  position: relative;
		  overflow: hidden;
		  /*transition: .01s;*/
		  -webkit-transform: translateZ(0);
		}
		li{
		  width: 170px;
		  height: 170px;
		  background: #FAFAFA;
		  border-radius:20px;
		  border:1px #E9E9E9 solid;
		  box-sizing: border-box;
		  overflow: hidden;
		  display: inline-block;
		  margin:0 20px 30px 0;
		  position: absolute;
		  left: 0;
		  top: 0;
		  -webkit-transform: translateZ(0);
		  /*<!--&:nth-child(5){-->*/
			/*<!--margin-left: -40px;-->*/
		  /*<!--}-->*/
		  /*&:nth-child(odd){*/
			/*float: left;*/
		  /*}*/
		  img{
			width: 168px;
			height: 168px;
			border-radius:20px;
		  }
		}
		
		
		
		.swiperSlide{
		  width: 170px;
		  height: 170px;
		  background: #FAFAFA;
		  border-radius:20px;
		  border:1px #E9E9E9 solid;
		  box-sizing: border-box;
		  overflow: hidden;
		  img{
			width: 100%;
			height: 100%;
		 }
		 
		 &:nth-child(2){
		   margin-left: -40px;
		 }
		}
	  }
	  .noData{
		text-align: center;
		padding-top: 120px;
		img{
		  width: 590px;
		}
		
	  }
	}
	
	
	
  }
}
</style>
